/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PropertyValueHint = {
    None: 'None',
    IsDynamic: 'IsDynamic'
} as const;
export type PropertyValueHint = typeof PropertyValueHint[keyof typeof PropertyValueHint];


export function PropertyValueHintFromJSON(json: any): PropertyValueHint {
    return PropertyValueHintFromJSONTyped(json, false);
}

export function PropertyValueHintFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyValueHint {
    return json as PropertyValueHint;
}

export function PropertyValueHintToJSON(value?: PropertyValueHint | null): any {
    return value as any;
}

/**
 * Check if a given object implements the PropertyValueHint interface.
 */
 export function instanceOfPropertyValueHint(value: any): value is PropertyValueHint {
    return Object.values(PropertyValueHint).includes(value)
}

